import React from 'react';

export const CustomAxisLabelImage = ({
  tick,
  xOffset = -13,
  yOffset = 8,
}: {
  tick: any;
  xOffset?: number;
  yOffset?: number;
}) => {
  return (
    <g transform={`translate(${tick.x + xOffset},${tick.y + yOffset})`}>
      <svg height="26" width="26">
        <defs>
          <clipPath id="myCircle">
            <circle cx="13" cy="13" r="13" fill="#FFFFFF" />
          </clipPath>
        </defs>
        <image width="26" height="26" xlinkHref={tick.value} clipPath="url(#myCircle)" />
      </svg>
    </g>
  );
};
